import React, { useCallback } from 'react';
import * as df from 'date-fns';

import {
  DateTimeSlot,
  TimeSlotAvailability,
} from '../../../../../interfaces/merchants/resources/books';

import BooksCalendarButton from '../common/buttons/BooksCalendarButton';
import css from './InputBookingDateTimeMarubatsu.module.scss';

import BooksCalendar from '../common/calendar/BooksCalendar';

interface Props {
  loading: boolean;
  displayDates: Date[];
  events: {
    checkinTimes: string[];
    dates: { [date: string]: DateTimeSlot };
  };
  postable: boolean;
  onSubmit: (availability: TimeSlotAvailability) => void;
  onClickToday: () => void;
  onClickPrev: () => void;
  onClickNext: () => void;
}

const Calendar: React.FC<Props> = ({
  events,
  displayDates,
  loading,
  postable,
  onSubmit,
  onClickToday,
  onClickPrev,
  onClickNext,
}) => {
  const findEventAvailability = useCallback(
    (
      events: { [date: string]: DateTimeSlot },
      time: number,
    ): TimeSlotAvailability => {
      for (const t of Object.values(events)) {
        for (const a of t.availabilities) {
          if (a.time === time) {
            return a;
          }
        }
      }
      throw new Error();
    },
    [],
  );

  const handleClickCalendar = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      onSubmit(
        findEventAvailability(
          events.dates,
          parseInt(e.currentTarget.value, 10),
        ),
      );
    },
    [events, onSubmit, findEventAvailability],
  );

  if (displayDates.length === 0) {
    return null;
  }

  const dates = displayDates.map((d) => df.format(d, 'YYYY-MM-DD'));
  return (
    <div className={css.InputBookingDateTimeMarubatsu}>
      <div className={css.InputBookingDateTimeMarubatsu__ButtonContainer}>
        <BooksCalendarButton
          disabled={df.isSameDay(new Date(), dates[0])}
          customType="prev"
          value="prev"
          onClick={onClickPrev}
        />
        <BooksCalendarButton
          customType="today"
          value="today"
          onClick={onClickToday}
        />
        <BooksCalendarButton
          customType="next"
          value="next"
          onClick={onClickNext}
        />
      </div>
      <BooksCalendar
        loading={loading}
        postable={postable}
        dates={dates}
        events={events}
        onClick={handleClickCalendar}
      />
      <div className={css.InputBookingDateTimeMarubatsu__ButtonContainer}>
        <BooksCalendarButton
          disabled={df.isSameDay(new Date(), dates[0])}
          customType="prev"
          value="prev"
          onClick={onClickPrev}
        />
        <BooksCalendarButton
          customType="today"
          value="today"
          onClick={onClickToday}
        />
        <BooksCalendarButton
          customType="next"
          value="next"
          onClick={onClickNext}
        />
      </div>
    </div>
  );
};

export default Calendar;
